import React from 'react'
import {CategoriasMercadoItem} from './CategoriasMercadoItem'

function CategoriasMercado(props) {
  const displayItems = (props) => {
    if (props) {
      const categories = props.categories

      console.log(categories)

      if (categories) {
        if (categories.length > 0) {
          return categories.map((category, index) => {
            return (
              <CategoriasMercadoItem
                key={index}
                category={category}
                editCategory={props.editCategory}
              />
            )
          })
        } else {
          return <h3>No hay categorias</h3>
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return <>{displayItems(props)}</>
}

export {CategoriasMercado}
